<template>
  <div class="container" id="nosotros">
    <div class="section">
      <div class="row">
        <div class="col s12 center-align">
          <h1 class="blue-text text-darken-4">Tecnología que se Traduce en Resultados</h1>
          <p style="text-align: center">
            <a href="/contact"><img src="@/assets/img/ti-project.jpg" alt="CONSIGUE QUE TU PROYECTO DESTAQUE SOBRE LOS DEMÁS" class="responsive-img" /></a>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m4">
          <h5 class="blue-text text-darken-3">Administración de Innovación</h5>
          <p>Dirijo programas de innovación que convierten ideas en productos rentables: roadmaps, validación con usuarios y gobernanza de cartera para priorizar iniciativas de alto impacto.</p>
        </div>
        <div class="col s12 m4">
          <h5 class="blue-text text-darken-3">Arquitectura de Sistemas Escalable</h5>
          <p>Diseño arquitecturas seguras y escalables (cloud‑native, microservicios e integraciones) alineadas a objetivos de negocio para optimizar costos, rendimiento y crecimiento sostenible.</p>
        </div>
        <div class="col s12 m4">
          <h5 class="blue-text text-darken-3">Desarrollo Full‑Stack y Entrega Continua</h5>
          <p>
            Construyo soluciones end‑to‑end con APIs robustas, interfaces centradas en el usuario y pipelines CI/CD, asegurando velocidad de entrega y código mantenible que acelera tu time‑to‑market.
          </p>
        </div>
      </div>

      <div class="row center">
        <a href="/contact" class="waves-effect waves-light btn blue darken-2 white-text"><i class="material-icons left">work</i>Trabajemos Juntos</a>
      </div>
    </div>
  </div>
</template>
